<template>
  <validation-observer
    v-slot="addressContactObserver"
    slim
  >
    <form-section
      id="address-contact"
      v-bind="addressContactObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="Is your postal address the same as the one being insured?"
        :error="formObserver.validated && !addressContactObserver.valid"
      >
        <validation-provider
          v-slot="{ failed }"
          name="Is Postcode Contact"
          :vid="`${stepId}_address-contact`"
          rules="required"
          slim
        >
          <radio
            v-model="isPostalAddressSameAsInsured"
            name="is-postal-address-insured"
            wide
            :error="failed"
            :items="constants.YES_NO"
            :data-test="snakeCase(questionFields.postcodeContact)"
          />
        </validation-provider>
      </form-row>
      <help-text
        :error="formObserver.validated && !addressContactObserver.valid"
      >
        Please select 'No' if your policy documentation should be sent to a different address
      </help-text>

      <template
        v-if="!helpers.isNull(isPostalAddressSameAsInsured) && !isPostalAddressSameAsInsured"
      >
        <form-section-highlight
          class="mt-12"
          :class="{ 'reset-styles': isAddressSelected }"
        >
          <component
            :is="'question-address'"
            ref="address"
            class="postcode-contact-control"
            product-name="home"
            step-id="insured"
            :form-observer="formObserver"
            :form-data="formData"
            :step-data="contactAddressStepData"
            :has-starts-with-validation="false"
            title="Please confirm your correspondence postcode"
            @input="handleAddressChange"
          />
        </form-section-highlight>
      </template>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

export default {
  name: 'question-postcode-contact',
  extends: QuestionBase,
  data () {
    return {
      fields: [
        'postcodeContact',
        'houseNumberOrNameContact',
      ],
      isPostalAddressSameAsInsured: true,
    };
  },
  computed: {
    contactAddressStepData () {
      return {
        postcode: this.questionData.postcodeContact,
        houseNumberOrName: this.questionData.houseNumberOrNameContact,
      };
    },
    isAddressSelected () {
      return this.questionData.postcodeContact && this.questionData.houseNumberOrNameContact;
    },
  },
  created () {
    this.init();
  },
  methods: {
    init () {
      this.setContactAddress();

      this.$watch('isPostalAddressSameAsInsured', {
        handler (isSame) {
          if (isSame) {
            this.questionData.postcodeContact = this.formData.home.postcode;
            this.questionData.houseNumberOrNameContact = this.formData.home.houseNumberOrName;
          } else {
            this.questionData.postcodeContact = null;
            this.questionData.houseNumberOrNameContact = null;
          }
        },
      });
    },
    setContactAddress () {
      const addressSelected = !!this.formData.home.postcode && !!this.formData.home.houseNumberOrName;

      const isContactAddressSelected = !!this.questionData.postcodeContact && !!this.questionData.houseNumberOrNameContact;

      if (!addressSelected) {
        this.isPostalAddressSameAsInsured = null;
        return;
      }

      if (addressSelected && isContactAddressSelected) {
        const isSame = this.formData.home.postcode === this.questionData.postcodeContact && this.formData.home.houseNumberOrName === this.questionData.houseNumberOrNameContact;

        this.isPostalAddressSameAsInsured = isSame;
      } else {
        this.isPostalAddressSameAsInsured = true;
        this.questionData.postcodeContact = this.formData.home.postcode;
        this.questionData.houseNumberOrNameContact = this.formData.home.houseNumberOrName;
      }
    },
    handleAddressChange ({
      postcode,
      houseNumberOrName,
    }) {
      this.questionData.postcodeContact = postcode;
      this.questionData.houseNumberOrNameContact = houseNumberOrName;
    },
  },
};
</script>

<style lang='scss'>
.postcode-contact-control {
  // reset question address styles
  .form-section__container {
    padding: 0;
  }

  .form-section__validity {
    display: none;
  }

  .form-section__container-holder {
    padding-right: 0;
  }

  .form-section-label {
    font-size: 18px !important;
  }

  .btn {
    min-width: 64px !important;
  }
  // end reset question address styles
}
</style>

<style lang='scss' scoped>
.reset-styles {
  &.form-section-highlight {
    border-left: none;
    padding-left: 0;
  }

  .form-row__label {
    display: none;
  }
}
</style>
